import { baseServiceRequest } from "../baseServiceRequest"
import type { ICampaign, ICampaignsRequestParams } from "./types"

export const getCampaigns = async (
  params?: ICampaignsRequestParams,
): Promise<ICampaign[]> => {
  const response = await baseServiceRequest({
    method: "GET",
    url: `/campaigns/`,
    params,
  })
  return response.data
}
